;(function () {
  angular
    .module('contrast.applications.modals')
    .controller('AppGroupModalInstanceCtrl', AppGroupModalInstanceCtrl)

  function AppGroupModalInstanceCtrl(
    $scope,
    $filter,
    $uibModalInstance,
    logger,
    appgroups,
    selectedapps,
    ApplicationFactory,
    ErrorService
  ) {
    'ngInject'

    $scope.model = {}
    $scope.model.groups = []
    $scope.groupInfo = {}
    var noGroup = '-- No Group --'

    initGroups()

    function initGroups() {
      $scope.model.groups = angular.copy(appgroups.data.groups)
      $scope.model.groups.push(noGroup)
    }

    $scope.save = function () {
      if ($scope.groupInfo.newGroup) {
        ApplicationFactory.updateAppGroup({
          apps: $filter('getByKey')(selectedapps, 'app_id'),
          group_name: $scope.groupInfo.newGroup
        }).then(
          function (response) {
            logger.logSuccess(response.data.messages[0])
            $uibModalInstance.close()
          },
          function (response) {
            ErrorService.processError(response)
          }
        )
      } else if ($scope.groupInfo.selectedExistingGroup) {
        if (angular.equals($scope.groupInfo.selectedExistingGroup, noGroup)) {
          ApplicationFactory.clearGroup({
            apps: $filter('getByKey')(selectedapps, 'app_id'),
            group_name: ''
          }).then(
            function (response) {
              logger.logSuccess(response.data.messages[0])
              $uibModalInstance.close()
            },
            function (response) {
              ErrorService.processError(response)
            }
          )
        } else {
          ApplicationFactory.updateAppGroup({
            apps: $filter('getByKey')(selectedapps, 'app_id'),
            group_name: $scope.groupInfo.selectedExistingGroup
          }).then(
            function (response) {
              logger.logSuccess(response.data.messages[0])
              $uibModalInstance.close()
            },
            function (response) {
              ErrorService.processError(response)
            }
          )
        }
      }
    }

    $scope.cancel = function () {
      $uibModalInstance.dismiss('cancel')
    }
  }
})()
